import { FormDateInput, FormTimeInput } from "@vesatogo/grass-dates"
import dayjs from "dayjs"
import { FormCard } from "~/components/FormCard"

export const WhenIsItProduction = ({ form, inputProps, isFinal }: any) => {
  return (
    <FormCard title="When is it Production">
      <div className={"grid grid-cols-1 md:grid-cols-4 gap-6"}>
        <FormDateInput
          label="Start Date"
          required
          {...inputProps("start_date_time")}
        />

        <FormTimeInput
          label="Start Time"
          {...inputProps("start_date_time")}
          defaultValue={dayjs().format("HH:mm")}
        />
        {isFinal && (
          <>
            <FormDateInput
              label="End Date"
              required
              {...inputProps("end_date_time")}
            />
            <FormTimeInput
              label="End Time"
              {...inputProps("end_date_time")}
              defaultValue={dayjs().format("HH:mm")}
            />
          </>
        )}
      </div>
    </FormCard>
  )
}
